module.exports = __webpack_public_path__ + "static/media/health-placeholder.4477f39f.webp";